import { createContext, useReducer } from 'react';

const initialState = {
    type: 'save', // 'save' or 'edit'
    name: '',
    id: null
};

export const EditTypeContext = createContext(null);
export const EditTypeDispatch = createContext(null);

function editTypeReducer(state, action) {
    switch (action.type) {
        case 'setType':
            return { ...state, type: action.payload };
        case 'setName':
            return { ...state, name: action.payload };
        case 'setId':
            return { ...state, id: action.payload };
        default:
            throw new Error(`Unknown action: ${action.type}`);
    }
}

export function EditTypeProvider({ children }) {
    const [state, dispatch] = useReducer(editTypeReducer, initialState);

    return (
        <EditTypeContext.Provider value={state}>
            <EditTypeDispatch.Provider value={dispatch}>
                {children}
            </EditTypeDispatch.Provider>
        </EditTypeContext.Provider>
    );
}